import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";

const links = [
  { label: "Home", to: "/", id: "home" },
  { label: "Shop", to: "/shop", id: "shop" },
  { label: "About Us", to: "/about", id: "about" },
  { label: "Contact", to: "/contact", id: "contact" },
];

const Navbar = () => {
  const { count } = useCart();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#F8F5F0]/75 border-b border-[#4A3F35]/10"
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-brand"
          className="font-serif-display text-xl sm:text-2xl tracking-tight text-[#4A3F35] leading-none"
        >
          Benz<span className="text-[#C6A769]">the</span>Brand
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.id}`}
              className={`relative pb-1 text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:text-[#C6A769] ${
                pathname === l.to
                  ? "text-[#C6A769] after:absolute after:left-0 after:right-0 after:bottom-0 after:h-px after:bg-[#C6A769]"
                  : "text-[#4A3F35]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-5">
          <Link
            to="/cart"
            data-testid="navbar-cart-button"
            className="relative p-2 text-[#4A3F35] hover:text-[#C6A769] transition-colors duration-300"
          >
            <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-0.5 -right-0.5 bg-[#C6A769] text-[#FAF7F2] text-[10px] font-medium w-4 h-4 flex items-center justify-center rounded-full"
              >
                {count}
              </span>
            )}
          </Link>
          <button
            className="md:hidden p-2 text-[#4A3F35]"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-[#4A3F35]/10 bg-[#F8F5F0]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.id}`}
              className={`text-sm uppercase tracking-[0.2em] transition-colors duration-300 hover:text-[#C6A769] ${
                pathname === l.to ? "text-[#C6A769]" : "text-[#4A3F35]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
